import avatarFreeToPro from '@/assets/image/free-to-pay/avatar-david-canes.svg';
import { PaywallFreeBgMobileJpg } from '@/assets/image/free-to-pay/paywall-free-bg-mobile-jpg';
import { cn } from '@/lib/cn';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import { Badge } from '@heidi/design-system/badge';
import {
  TypographyCaption,
  TypographyH1,
  TypographyP2Bold,
} from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import Image from 'next/image';
import { Trans } from 'react-i18next';
import { TrustPilotReviewMobileTrial } from './trust-pilot-review-mobile-trial';

interface PaywallOverlayTrialProps {
  trialToPaidModalOpen: boolean;
}

export const PaywallOverlayTrial = ({
  trialToPaidModalOpen,
}: PaywallOverlayTrialProps) => {
  const { t } = useTranslations();

  if (isAppleCompliantBuild()) return null;

  return (
    <div
      id="paywall-overlay-trial"
      className={cn(
        'fixed inset-0 z-50 flex size-full flex-col items-start justify-start gap-y-6 bg-transparent p-4 text-text-primary-invert opacity-100 transition-all duration-500 sm:hidden',
        !trialToPaidModalOpen && 'z-[-1] opacity-0'
      )}
    >
      <PaywallFreeBgMobileJpg
        alt=""
        fill
        className="absolute left-0 top-0 z-[-1] object-cover"
      />
      <div className="flex w-full justify-end" />
      <Badge color="inverted" size="sm" className="mb-2">
        {t('upgradeProModal.cancelAnytime')}
      </Badge>
      <div className="flex flex-col items-start gap-y-4">
        <TypographyH1 className="text-3xl text-text-primary-invert newBrand:text-text-primary sm:max-w-87.5 sm:text-4xl lg:max-w-full lg:text-5xl">
          <Trans
            i18nKey="upgradeProModal.testimonial"
            components={{
              br: <br />,
            }}
          >
            &quot;Custom templates change the game... <br /> I&apos;m in love.&quot;
          </Trans>
        </TypographyH1>
        <div className="flex max-w-[400px] items-center gap-3">
          <Image src={avatarFreeToPro} alt="avatar" height={32} width={32} />
          <div className="flex flex-col">
            <TypographyP2Bold className="text-text-primary-invert newBrand:text-text-primary">
              {t('upgradeProModal.doctorName')}
            </TypographyP2Bold>
            <TypographyCaption className="text-text-primary-invert newBrand:text-text-primary">
              {t('upgradeProModal.doctorTitle')}
            </TypographyCaption>
          </div>
        </div>
      </div>
      <TrustPilotReviewMobileTrial />
    </div>
  );
};
